import {repeatOptions, timesOptions, timeWindowOptions} from "../ToDos";
import {useContext, useEffect, useState} from "react";
import SelectWeex from "../elements/SelectWeex";
import Select2Weex from "../elements/Select2Weex";
import Select2DateWeex from "../elements/Select2DateWeex";
import NumberInputWeex from "../elements/NumberInputWeex";
import {APIContext} from "../Globals.tsx";

export default function AddCourse({
                                      initBegin,
                                      initEnd,
                                      style,
                                      onSave,
                                      onAbort,
                                      editValues = null,
                                      weekday = null,
                                      startOfWeek,
                                      checkbox,
                                      courseTypes,
                                      locations,
                                      coaches
                                  }){
    const [date] = useState(new Date(startOfWeek).setDate(new Date(startOfWeek).getDate() + weekday));
    const [courseTemp] = useState(editValues ? editValues.courseTemp : null);
    const [id] = useState(editValues ? editValues.id : null);
    const [selectedType, setSelectedType] = useState(editValues ? courseTypes.find(e => e.short === editValues.type) : courseTypes[0]);
    const [begin, setBegin] = useState(editValues ? {
        value: editValues.startTime,
        label: editValues.startTime
    } : {label: initBegin, value: initBegin});
    const [end, setEnd] = useState(editValues ? {
        value: editValues.endTime,
        label: editValues.endTime
    } : {label: initEnd, value: initEnd});
    const [endDate, setEndDate] = useState(editValues ? new Date(editValues.endDate) : new Date(new Date(date).setFullYear(new Date(date).getFullYear() + 1)));
    const [startDate, setStartDate] = useState(editValues ? new Date(editValues.startDate) : new Date(date));
    const [coach, setCoach] = useState(editValues ? coaches.find(e => editValues.coach === e.id) : "");
    const [location, setLocation] = useState(editValues ? locations.find(e => e.id === editValues.location) : "");
    const [repeat, setRepeat] = useState(editValues ? editValues.repeat?.map(e => repeatOptions.find(e_ => e_.value === e)) : null);
    const [signInWindow, setSignInWindow] = useState(editValues ? timeWindowOptions.find((t) => t.value === editValues.signInWindow?.toString()) : null);
    const [signOutWindow, setSignOutWindow] = useState(editValues ? timeWindowOptions.find((t) => t.value === editValues.signOutWindow?.toString()) : null);
    const [participantsMax, setParticipantsMax] = useState(editValues ? editValues.participantsMax : 12);
    const [status, setStatus] = useState(editValues ? editValues.status : null);
    const [index] = useState(editValues ? editValues.index : -1);
    const [isEditing, _] = useState(!!editValues)
    // Listen von Vertrags-repeat-Strings
    // visibleFor: null = fuer alle sichtbar
    // partVisibleFor: [] = fuer keinen sichtbar (Default), null = fuer alle sichtbar ("Alle"-Option)
    const [visibleFor, setVisibleFor] = useState(editValues?.visibleFor ?? null);
    const [partVisibleFor, setPartVisibleFor] = useState(editValues ? editValues.partVisibleFor : []);
    const [contractOptions, setContractOptions] = useState([]);
    const {getContracts} = useContext(APIContext);

    useEffect(() => {
      getContracts(false).then(ans => {
        if(!ans?.contracts)
          return;
        setContractOptions([
          ...ans.contracts.map(contract => ({
            // gleiches Format wie Person.js: repeat_tickets bzw. all_in
            value: !contract.repeat.includes("all_in") ? contract.repeat + "_" + contract.tickets : contract.repeat,
            label: contract.name
          }))
        ]);
      });
    }, []);

    const allOption = {value: "all", label: "Alle"};
    const partOptions = [allOption, ...contractOptions];
    const toValues = (selected) => selected?.length > 0 ? selected.map(e => e.value) : null;
    // "Alle" => null, keine Auswahl => []
    const toPartValues = (selected) => !selected || selected.length === 0 ? [] : selected.some(e => e.value === allOption.value) ? null : selected.map(e => e.value);

    function callOnSave(){
        onSave({
            id: id,
            courseTemp: courseTemp,
            "type": selectedType ? selectedType.short : null,
            "startTime": begin.value,
            "endTime": end.value,
            startDate,
            signInWindow: signInWindow?.value,
            signOutWindow: signOutWindow?.value,
            endDate: repeat?.length > 0 ? endDate : startDate,
            coach: coach ? coach.id : null,
            location: location ? location.id : null,
            repeat: repeat?.length > 0 ? repeat.map(e => e.value) : null,
            participantsMax,
            status,
            index,
            // Sichtbarkeit gilt pro Template, daher nur im Serien-Modus
            ...(checkbox ? {visibleFor, partVisibleFor} : {})
        });
    }

    function setBoth(e){
        setStartDate(e);
        setEndDate(e);
    }

    useEffect(() => {
        let todaySet = new Date(new Date().setHours(21, 59, 59)); //because before post data we add 2 hours todo this is not working in other timezones
        if(endDate < todaySet){
            setEndDate(todaySet);
        }
        if(startDate < todaySet){
            setStartDate(todaySet);
        }
        if(startDate > endDate){
            setEndDate(startDate);
        }
    }, [startDate, endDate]);

    useEffect(() => {
        let start_ = new Date(new Date("2000-01-01T" + begin?.value).setMinutes(new Date("2000-01-01T" + begin?.value).getMinutes() + 15));
        let end_ = new Date("2000-01-01T" + end?.value);
        if(end_ < start_){
            let min = start_.getMinutes().toString().length > 1 ? start_.getMinutes().toString() : "0" + start_.getMinutes().toString();
            let h = start_.getHours().toString().length > 1 ? start_.getHours().toString() : "0" + start_.getHours().toString();
            setEnd({label: h + ":" + min, value: h + ":" + min});
        }
    }, [begin, end]);

    useEffect(() => {
        if(!isEditing){
            let location = selectedType?.defaultLocation ? locations.find(e => e.id === selectedType.defaultLocation) : ""
            setCoach(selectedType?.defaultCoach ? coaches.find(e => selectedType.defaultCoach === e.id) : "");
            setLocation(location);
            setParticipantsMax(location? locations.find(loc=> loc.id === location.id).capacity: 12);
            setRepeat(selectedType?.defaultRepeat ? selectedType.defaultRepeat?.map(e => repeatOptions.find(e_ => e_.value === e)) : null);
            setSignInWindow(selectedType?.defaultSignInWindow ? timeWindowOptions.find((t) => t.value === selectedType.defaultSignInWindow?.toString()) : null);
            setSignOutWindow(selectedType?.defaultSignOutWindow ? timeWindowOptions.find((t) => t.value === selectedType.defaultSignOutWindow?.toString()) : null);
        }
    }, [selectedType]);

    return (<div className={"card addCourse"} style={style}>

        <SelectWeex placeholder={"Kurstyp wählen"} value={selectedType} options={courseTypes ?? []}
                    onChange={(e) => setSelectedType(e)} isSearchable={false} label={"Kurstyp"}/>

        <br/>
        <div style={{display: "flex", flexDirection: "row"}}>
            <SelectWeex placeholder={"Ort"} value={location} options={locations ?? []} onChange={(e) => setLocation(e)} style={{width: "100%"}} label={"Ort"}/>
            <NumberInputWeex value={participantsMax} onChange={setParticipantsMax} style={{width: 100}} label={"Teilnehm."}/>
        </div>
        <br/>
        <SelectWeex placeholder={"Kein Coach zugewiesen"} value={coach} options={coaches ?? []}
                    onChange={(e) => setCoach(e)} label={"Coach"}/>
        <Select2Weex label={"Beginn"} placeholder={begin} options={timesOptions}
                     onChange={setBegin} value={begin}/>
        <Select2Weex label={"Ende"} placeholder={end} options={timesOptions}
                     onChange={setEnd} value={end}/>
        {checkbox && <div>
            <Select2Weex label={"Anmeldung bis"} placeholder={"xy min vorher"}
                         options={timeWindowOptions} onChange={setSignInWindow} value={signInWindow}/>
            <Select2Weex label={"Abmeldung bis"} placeholder={"xy min vorher"}
                         options={timeWindowOptions} onChange={setSignOutWindow} value={signOutWindow}/>
            <Select2Weex label={"Wiederholung"} placeholder={"Wöchentlich"}
                         options={repeatOptions.map(e => e.value === weekday.toString() ? {
                             value: e.value,
                             label: "Wöchentlich"
                         } : e)} isMulti={true} onChange={setRepeat} value={repeat}/>
            {repeat ? <div><Select2DateWeex label={"Startdatum"} onChange={setStartDate} value={startDate}/>
                    <Select2DateWeex label={"Enddatum"} onChange={setEndDate} value={endDate}/></div> :
                <Select2DateWeex label={"Datum"} onChange={setBoth} value={startDate}/>}
        </div>}
        <div className={"flex-row centerVertical"} style={{height: 30, marginBottom: 10}} onClick={() => setStatus(old => old ? "" : "kostenlos")}>
            <input type={"radio"} name={"status"}
                   checked={status === "kostenlos"}/>Kostenlos</div>
        {checkbox && <>
          <div className={"flex-row centerVertical"}>
            <SelectWeex placeholder={"Kurs sichtbar für alle"} label={"Kurs sichtbar für (leer = alle)"} isMulti={true}
                        value={contractOptions.filter(o => visibleFor?.includes(o.value))} options={contractOptions}
                        onChange={(e) => setVisibleFor(toValues(e))}/>
          </div>
          <div className={"flex-row centerVertical"}>
            <SelectWeex placeholder={"Teilnehmer sichtbar für keinen"} label={"Teilnehmer sichtbar für (leer = keiner)"} isMulti={true}
                        value={partVisibleFor === null ? [allOption] : contractOptions.filter(o => partVisibleFor?.includes(o.value))} options={partOptions}
                        onChange={(e) => setPartVisibleFor(toPartValues(e))}/>
          </div>
        </>}
        <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "5%"}}>
            <button className={"secondarybutton"} onClick={onAbort}>Abbrechen</button>
            <button className={"primarybutton"} onClick={callOnSave} disabled={!selectedType}>Hinzufügen</button>
        </div>
    </div>);
}